import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { getOtpVerificationForm } from './phone-email-otp-verification.component.element';

@Component({
	selector: 'app-phone-email-otp-verification',
	templateUrl: './phone-email-otp-verification.component.html',
	styleUrls: ['./phone-email-otp-verification.component.css']
})
export class PhoneEmailOtpVerificationComponent implements OnInit {
	otpVerificationForm: any;
	@Output() verifyOtp = new EventEmitter();
	constructor() {}

	ngOnInit() {
		this.otpVerificationForm = getOtpVerificationForm();
	}

	onVerifyOtp(data) {
		this.verifyOtp.emit(data);
	}
}
